import { AnimatePresence, motion } from "motion/react";
import { X } from "lucide-react";
import { useCart } from "@/theme2/hooks/useCart";
import MiniCartItem from "@/theme2/components/cart/MiniCartItem";
import MiniCartFooter from "@/theme2/components/cart/MiniCartFooter";
import CartEmpty from "@/theme2/components/cart/CartEmpty";

export default function MiniCart({ open, onClose }) {
  const { cart, totals, cartCount, remove, updateQuantity } = useCart();

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[70]">
          <motion.button
            type="button"
            aria-label="Close cart"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
          />

          <motion.aside
            role="dialog"
            aria-modal="true"
            aria-label="Shopping cart"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.28, ease: "easeOut" }}
            className="absolute bg-white right-0 top-0 flex h-full w-full flex-col  shadow-2xl sm:w-[420px]"
          >
            <header className="flex items-center justify-between border-b border-border p-5">
              <div>
                <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                  Cart
                </p>
                <h2 className="text-2xl font-black">Your Bag ({cartCount})</h2>
              </div>

              <button
                type="button"
                onClick={onClose}
                className="rounded-full border border-border p-2"
              >
                <X className="size-5" />
              </button>
            </header>

            <div className="flex-1 overflow-y-auto p-5">
              {cart.length ? (
                <div className="space-y-4">
                  {cart.map((item) => (
                    <MiniCartItem
                      key={`${item.slug}-${item.selectedColor}-${item.selectedSize}`}
                      item={item}
                      onRemove={remove}
                      onQuantityChange={updateQuantity}
                    />
                  ))}
                </div>
              ) : (
                <CartEmpty compact onContinue={onClose} />
              )}
            </div>

            {cart.length > 0 && (
              <MiniCartFooter totals={totals} onClose={onClose} />
            )}
          </motion.aside>
        </div>
      )}
    </AnimatePresence>
  );
}
